const templateUrl = require('./reactivate-subscription-dialog.html');

const inject = ['subscriptionOrchestrator', '$state', '$translate', 'dialogService', 'toastService'];

function ReactivateSubscriptionControllerFactory(subscriptionOrchestrator, $state, $translate, dialogService, toastService) {
  class ReactivateSubscriptionController {
    reactivate() {
      if (this.subscription.product.discontinued) {
        return false;
      }

      return dialogService.open({
        templateUrl: templateUrl,
        confirmText: $translate.instant('MODAL_REACTIVATE_SAVE'),
        onSuccess: () => subscriptionOrchestrator.reactivateSubscription(this.subscription)
          .then(() => toastService.translate.success('TOAST_REACTIVATE_SUCCESS'))
          .then($state.reload)
          .catch(() => toastService.translate.danger('TOAST_REACTIVATE_DANGER')),
        windowTopClass: 'og-reactivate-sub-modal',
        ariaLabelledBy: 'og-reactivate-subscription-modal-title',
        ariaDescribedBy: 'og-reactivate-subscription-modal-description'
      }).result;
    }
  }
  return new ReactivateSubscriptionController();
}

ReactivateSubscriptionControllerFactory.$inject = inject;

angular.module('msi.subscriptions')
  .controller('ReactivateSubscriptionController', ReactivateSubscriptionControllerFactory);

module.exports = ReactivateSubscriptionControllerFactory;
